// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"aa353929","300":"7e8cfa17","493":"75c1348c","623":"c3dc959d","930":"1eed5c87","964":"bc4c4842"}[chunkId] + ".ab98a889e3f3.chunk.js";
};